'use client';
import InfoLayout from '@/layout/InfoLayout';

export default function Layout({ children }) {
  return <InfoLayout>{children}</InfoLayout>;
}
